module.exports = __webpack_public_path__ + "static/media/Livre6.639268a2.png";